<template>
  <a-layout>
    <a-form-model
      ref="form"
      :model="maintenanceConfig"
      :rules="rules">
      <a-row>
        <a-col span="12">
          <a-form-model-item ref="no" :label-col="labelCol" :wrapper-col="wrapperCol" :label="$t('business.label.warehouse')" prop="warehouse">
            <a-input disabled v-model="warehouse.name" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol" :label="$t('business.label.storer')" prop="storer">
            <a-select v-model="maintenanceConfig.storer.id">
              <a-select-option v-for="d in storerData" :key="d.id">{{ d.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="12">
          <a-form-model-item ref="no" :label-col="labelCol" :wrapper-col="wrapperCol" :label="$t('business.label.logicalStore')" prop="logicalStoresName">
            <a-input-search
              v-model="maintenanceConfig['logicalStoresName']"
              @dblclick="search('logicalStoreModal',{available:true,'storer.id':maintenanceConfig.storer.id},maintenanceConfig.logicalStores)"
              @pressEnter="search('logicalStoreModal',{available:true,'storer.id':maintenanceConfig.storer.id},maintenanceConfig.logicalStores)"
              readOnly
              @search="search('logicalStoreModal',{available:true,'storer.id':maintenanceConfig.storer.id})"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item ref="no" :label-col="labelCol" :wrapper-col="wrapperCol" :label="$t('business.label.itemCategory')" prop="itemCategoriesName">
            <a-input-search
              @dblclick="search('itemCategoryModal',null,maintenanceConfig.itemCategories)"
              @pressEnter="search('itemCategoryModal',null,maintenanceConfig.itemCategories)"
              @search="search('itemCategoryModal',null,maintenanceConfig.itemCategories)"
              readOnly
              v-model="maintenanceConfig['itemCategoriesName']"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <logical-store-modal ref="logicalStoreModal" select-type="checkbox" :title="$t('business.label.logicalStore')" @change="logicStoreChange" />
    <field-modal ref="itemCategoryModal" :no=itemCategoryNo :show-name="true" select-type="checkbox" @change="itemCategoryChange"/>
  </a-layout>
</template>

<script>
import { findAll, findOne, post } from '@/api/Api'
  import { Storer } from '@/api/dto/common/Storer'
  import Vue from 'vue'
  import { WAREHOUSE } from '@/store/mutation-types'
  import FieldModal from '@/views/modal/FieldModal.vue'
  import { getStrings } from '@/utils/util'
  import api from '@/api'
  import LogicalStoreModal from '@/views/modal/LogicalStoreModal.vue'

  export default {
    name: 'MaintenanceConfigDetail',
    components: { LogicalStoreModal, FieldModal },
    data() {
      return {
        loading: false,
        warehouse: Vue.ls.get(WAREHOUSE),
        maintenanceConfig: {
          storer: new Storer(),
          itemCategories: [],
          logicalStores: [],
          'itemCategoriesName': '',
          'logicalStoresName': ''
        },
        itemCategoryNo: '',
        labelCol: { span: 5 },
        wrapperCol: { span: 15 },
        rules: {
          'storerId': [{ required: true, message: '货主不能为空' }],
          'logicalStoresName': [{ required: true, message: '逻辑仓不能为空' }],
          'itemCategoriesName': [{ required: true, message: '商品类别不能为空' }]
        },
        storerData: []
      }
    },
    mounted() {
      findOne('parameterFactory', { name: '商品类别层级' }).then(res => {
        if (res.success) {
          this.itemCategoryNo = res.result.value
        }
      })
      findAll('storerFactory').then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
    },
    methods: {
      getData(record) {
        Object.assign(this.maintenanceConfig, record)
        this.maintenanceConfig['logicalStoresName'] = getStrings(record.logicalStores, 'name')
        this.maintenanceConfig['itemCategoriesName'] = getStrings(record.itemCategories, 'name')
      },
      search(refName, args, data) {
        if (this.maintenanceConfig.storer.id === null || this.maintenanceConfig.storer.id === undefined) {
          return this.$message.warning('请先选择货主')
        }
        this.$refs[refName].open(args, null, data)
      },
      logicStoreChange(logicalStores) {
        if (logicalStores.length > 0) {
          this.maintenanceConfig['logicalStoresName'] = getStrings(logicalStores, 'name')
        } else {
          this.maintenanceConfig['logicalStoresName'] = ''
        }
        this.maintenanceConfig['logicalStores'] = logicalStores
      },
      itemCategoryChange(itemCategories) {
        if (itemCategories.length > 0) {
          this.maintenanceConfig['itemCategoriesName'] = getStrings(itemCategories, 'name')
        } else {
          this.maintenanceConfig['itemCategoriesName'] = ''
        }
        this.maintenanceConfig['itemCategories'] = itemCategories
      },
      clear() {
        this.maintenanceConfig = {
          storer: new Storer(),
          logicalStores: [],
          itemCategories: [],
          'logicalStoresName': '',
          'itemCategoriesName': ''
        }
      },
      save() {
        this.$refs.form.validate((success) => {
          if (success) {
            if (this.maintenanceConfig.logicalStores.length === 0) {
              return this.$message.warning('逻辑仓不能为空')
            }
            if (this.maintenanceConfig.itemCategories.length === 0) {
              return this.$message.warning('商品类别不能为空')
            }
            const saveData = {
              'storer.id': this.maintenanceConfig.storer.id,
              'logicalStore.ids': this.maintenanceConfig.logicalStores.map(item => item.id),
              'itemCategory.ids': this.maintenanceConfig.itemCategories.map(item => item.id),
              autoGenerate: true
            }
            post(api.save, { type: 'maintenanceConfigPersister' }, saveData).then(res => {
              if (res.success) {
                this.$success({
                  title: '提示',
                  content: '保存成功'
                })
                this.$emit('saveSuccess')
                this.clear()
              }
            })
          }
        })
      }
    }
  }
</script>